import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import settingsSlice from "./slices/settingsSlice";
import cartPaymentSlice from "./slices/cartPaymentSlice"

export const store = configureStore({
    reducer: {
        auth: authSlice,
        settings: settingsSlice,
        cart: cartPaymentSlice
    },
    devTools: process.env.NODE_ENV !== "production",
})